<script>
  import Html from '$lib/Html.svelte'
  import Image from '$lib/Image.svelte'

  export let items = []
</script>

<div class="items" class:threes={items.length % 2 !== 0}>
  {#each items as item}
    {@const { title, link, linkText, content, image } = item}
    <div class="item" class:linked={link}>
      <figure class="figure">
        <Image
          alt={image.alt || ''}
          src={image.url}
          class="img"
          {...image.dimensions}
          variants={[1600, 1300, 1000, 900, 600]}
          sizes="(min-width: 600px) 40vw, 90vw" />
      </figure>
      <div class="body">
        <Html size="small" muted>
          <h3>{title}</h3>
          <slot {content} />
          {#if link}
            <a href={link} class="link">
              {linkText}
            </a>
          {/if}
        </Html>
      </div>
    </div>
  {/each}
</div>

<style>
  .items {
    display: grid;
    gap: 2.5rem 2rem;
    text-wrap: balance;
  }

  .item {
    display: flex;
    flex-direction: column;
    gap: 1rem 1.75rem;
    position: relative;
  }

  .figure {
    display: block;
    width: 100%;
    border-radius: var(--border-radius-lg);
    overflow: hidden;
  }

  .link::before {
    content: '';
    position: absolute;
    inset: 0;
  }

  @media (min-width: 600px) {
    .items:not(.threes) {
      grid-template-columns: 1fr 1fr;
    }

    .threes .item {
      align-items: center;
      flex-direction: row;
    }

    .figure {
      border-radius: var(--border-radius-md);
    }

    .threes .figure {
      flex: 0 0 50%;
    }

    .threes .body {
      margin-top: -0.75rem;
    }
  }

  @media (min-width: 900px) {
    .items {
      gap: 2.5rem;
    }

    .threes {
      grid-template-columns: 1fr 1fr 1fr;
    }

    .item {
      gap: 1.5rem;
    }

    .threes .item {
      flex-direction: column;
      gap: 2rem;
      align-items: start;
    }

    .figure {
      border-radius: var(--border-radius-lg);
    }

    .threes .figure {
      flex: inherit;
    }
  }

  @media (min-width: 1200px) {
    .items {
      gap: 4rem;
    }
  }
</style>
